import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const CreateUserCoachDetailWrapper = styled.div`
  .coach-detail-container {
    padding: 0px 0 24px 16px;
    ${responsive.MOBILE`
      padding: 0px 16px 16px;
    `}
  }

  .cronofy-container {
    padding: 0px 0 24px 16px;
    ${responsive.MOBILE`
      padding: 0px 16px 16px;
    `}
  }

  .MuiAccordionSummary-expandIconWrapper {
    display: none;
  }
`;
